import { render, staticRenderFns } from "./viewProfileDialog.vue?vue&type=template&id=0300b81e&scoped=true"
import script from "./viewProfileDialog.vue?vue&type=script&lang=ts"
export * from "./viewProfileDialog.vue?vue&type=script&lang=ts"
import style0 from "./viewProfileDialog.vue?vue&type=style&index=0&id=0300b81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300b81e",
  null
  
)

export default component.exports